<template>
  <span class="wrapper">
    <span v-tooltip.bottom="{ content: tooltipContent, contentHtml: true }" :style="{ color: isRejected ? 'red' : 'inherit' }">
      {{ params.value }}
      <i v-if="isRejected" class="fas fa-info-circle"></i>
    </span>
  </span>
</template>

<script>
  export default {
    computed: {
      isRejected() {
        var rejectStatuses = ['Rejected', 'Exported - Rejected', 'Posted - Rejected']
        return rejectStatuses.includes(this.params.value)
      },
      tooltipContent() {
        return !this.isRejected ? this.params.value : this.getRejectionReason()
      }
    },
    methods: {
      getRejectionReason() {
        return 'Decline Reason: ' + this.params.data.RejectionReason + '<br>Only ' + this.params.data.CreatedByUser + ' can edit this envelope.'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-envelopes/EnvelopeStatus.vue